
import * as THREE from 'three'
import { useFrame, useThree } from "@react-three/fiber"
import { useRef, useState } from 'react';
const uniforms = {
    time: { value: 0 },
    scale: { value: 30 },
    intensity: { value: 3.5 },
    opacity: { value: 0.05},
    color1: { value: new THREE.Color("#FE76FF") },
    color2: { value: new THREE.Color("#4c1f78") },
  };

const BackgroundShader = ({size, divisions, backgroundColor}) =>{
const gridRef = useRef()
const gridHelperRef = useRef()
const division = 20;
const limit = 100;
const [timeValue,setTimeValue] = useState(0)
const { camera, gl, scene } = useThree()
const materialRef = useRef();
    const timeRef = useRef(0);
const planeRef = useRef()    
useFrame((state,delta)=>{
    // setTimeValue((prevState)=>prevState+delta)
    planeRef.current.rotation.z -= delta * 0.05
    timeRef.current += 0.01
    materialRef.current.uniforms.time.value = timeRef.current
    materialRef.current.uniforms.scale.value = timeRef.current
})
  

return <mesh scale={22} receiveShadow position={[0,0,0]} rotation={[-Math.PI /2,0,0]} ref={planeRef}>
    <planeGeometry args={[4.5,4.5]}/>
    <shaderMaterial
          needsUpdate
          ref={materialRef}
          uniforms={uniforms}
          vertexShader={`
            varying vec2 vUv;
            void main() {
              vUv = uv;
              gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
            }
          `}
          fragmentShader={`
          uniform float time;
uniform float scale;
uniform float intensity;
uniform float opacity;
uniform vec3 color1;
uniform vec3 color2;

varying vec2 vUv;

float random(vec2 st){
    return fract(sin(dot(st.xy, vec2(12.9898, 78.233))) * 43758.5453123);
}

float noise(vec2 st) {
    vec2 i = floor(st);
    vec2 f = fract(st);
    vec2 u = f * f * (3.0 - 2.0 * f);

    return mix(
        mix(random(i + vec2(0.0, 0.0)), random(i + vec2(1.0, 0.0)), u.x),
        mix(random(i + vec2(0.0, 1.0)), random(i + vec2(1.0, 1.0)), u.x),
        u.y
    );
}

void main() {
    float noiseValue = noise(vUv * scale);
    vec3 color = mix(color1, color2, noiseValue * intensity);
    gl_FragColor = vec4(color, opacity);
}
          `}
          transparent
        />
</mesh>
}

export default BackgroundShader